import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { Select } from 'antd'
import { PromoCodeType } from '../../../../../types'
import CentredLoader from '../../../../../components/CentredLoader'

const PROMO_CODES = gql`
  query promo_codes(
    $paymentType: String!
    $addressId: Int!
    $legalStatusId: Int!
  ) {
    promoCodes(
      paymentType: $paymentType
      addressId: $addressId
      legalStatusId: $legalStatusId
    ) {
      id
      identificationToken
      percentage
    }
  }
`

interface Props {
  onChange: any
  defaultPromoCodeId?: number
  paymentType: string
  addressId: number
  legalStatusId: number
  disabled: boolean
}

const PromoCodeSelect = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { Option } = Select

  const { data: promoCodesData, loading: promoCodeLoading } = useQuery(
    PROMO_CODES,
    {
      fetchPolicy: 'no-cache',
      variables: {
        addressId: props.addressId,
        legalStatusId: props.legalStatusId,
        paymentType: props.paymentType,
      },
    }
  )

  const onSelectionChange = (value: any) => {
    props.onChange(value)
  }

  if (promoCodeLoading) return <CentredLoader />

  const selectedPromoCode: PromoCodeType = promoCodesData.promoCodes.find(
    (promoCode: PromoCodeType) => {
      return promoCode.id == props.defaultPromoCodeId
    }
  )

  const placeholder = props.disabled
    ? t('promoCode.disabled')
    : t('promoCode.placeholder')

  return (
    <React.Fragment>
      <label>{t('promoCode.label')}</label>
      <Select
        allowClear
        showSearch
        defaultValue={selectedPromoCode?.id}
        placeholder={placeholder}
        onChange={onSelectionChange}
        onClear={() => onSelectionChange(null)}
        style={{ width: '100%' }}
        filterOption={(input, option) =>
          (option!.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        disabled={props.disabled}
      >
        {promoCodesData.promoCodes.map((promoCode: PromoCodeType) => {
          return (
            <Option key={promoCode.id} value={promoCode.id}>
              {promoCode.identificationToken}
            </Option>
          )
        })}
      </Select>
    </React.Fragment>
  )
}

export default PromoCodeSelect
